var _style, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApointmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 155.6",
    style: {
      enableBackground: "new 0 0 156 155.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF8533;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{font-family:'HYk1gj';}\n\t.st3{font-size:106.7121px;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,2.8h96c15.1,0,27.3,12.2,27.3,27.3v96c0,15.1-12.2,27.3-27.3,27.3H30c-15.1,0-27.3-12.2-27.3-27.3l0-96 C2.7,15.1,14.9,2.8,30,2.8z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0073 0 0 1 24.4047 112.2745)",
    className: "st1 st2 st3"
  }, "\u9884")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApointmentIcon);
export default __webpack_public_path__ + "static/media/apointmentIcon.dbdd0e9c.svg";
export { ForwardRef as ReactComponent };